import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import CustomerReviewCard from "./component";
import { getCustomerReviews } from "./actions";

const mapStateToProps = ({
    customerReviews: { isSSR, list, average, total}
}) => ({
    isSSR,
    list,
    average,
    total
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getCustomerReviewsConnect: getCustomerReviews
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerReviewCard));
